function getCountryAndLanguageTranslation(langCode) {
    let deferred = $.Deferred();
    // test.myNuskin.com/bin/mecommerce/countryAndLanguageTranslation?language=es;
    let countryAndLanguageTranslationURL =
        '/content/localization/countryandlanguagetranslation.service.{code}.json';
    $.ajax({
        type: "GET",
        url: countryAndLanguageTranslationURL.replace('{code}', langCode),
        success: data => {
            deferred.resolve(data);
        },
        error: xhr => {
            deferred.reject(xhr);
        }
    });
    return deferred.promise();
}
function updateMember(hostInfo, userObject, accountConfigManager, invitationType) {
    let deferred = $.Deferred();
    let postUrl = accountConfigManager.site.services.invitation_endpoint;

    let JSONObj = {};
    JSONObj.hostPersonID = hostInfo.hostPersonId.toUpperCase();
    JSONObj.guestPersonID = '';
    JSONObj.guestEmailAddress = '';
    JSONObj.type = invitationType;
    /* Generate messageData to store Host Info (Account ID , Host first name and last name*/
    JSONObj.messageData = {
        'ACCOUNTID': hostInfo.hostAccountId,
        'HOSTFIRSTNAME': hostInfo.hostFirstName,
        'HOSTLASTNAME': hostInfo.hostLastName
    };
    $.ajax({
        type: "POST",
        url: postUrl,
        dataType: "json",
        headers: {
            'client_id': accountConfigManager.site.clientId,
            'client_secret': accountConfigManager.site.clientSecret,
            'eid': userObject.eid
        },
        contentType: "application/json;charset=UTF-8",
        success: function(data) {
            deferred.resolve(data);
        },
        error: function(xhr) {
            deferred.reject(xhr);
        },
        data: JSON.stringify(JSONObj)
    });
    return deferred.promise();
}

function getRegions() {

}
function getShortUrl(url, accountConfigManager) {
    let shortenServiceKey = accountConfigManager.system.shortenURL_service_key;
    let shortenServiceUrl = accountConfigManager.system.shortenURL_service_url;
    let deferred = $.Deferred();
    let params = {
        longUrl: url,
        apiKey: shortenServiceKey
    };


    // For older versions of angular, use this
    $.ajax({
        url: shortenServiceUrl,
        dataType: 'json',
        data: params,
        headers: {
            showgloballoader: true
        },
        contentType: "application/json;charset=UTF-8",
        success: function(data) {
            deferred.resolve(data);
        }
    });
    return deferred.promise();
}
function getRealURLParamsForGUID(guid, eid, hostDetailsObj) {
    return '?guid='+guid+'&eid='+eid+'&param1='+hostDetailsObj.hostAccountId
        +'&param2='+hostDetailsObj.hostFirstName+'&param3='+hostDetailsObj.hostLastName;
}
function getRealURLParamsForUUID(uuid, eid, hostDetailsObj) {
    return '?uuid='+uuid+'&eid='+eid+'&param1='+hostDetailsObj.hostAccountId+
        '&param2='+hostDetailsObj.hostFirstName+'&param3='+hostDetailsObj.hostLastName;
}
function getShortUrlParams(invitationObj, hostInfo) {
    console.error("Deprecated Functionality has been removed");
}

export default {
    getCountryAndLanguageTranslation: getCountryAndLanguageTranslation,
    updateMember: updateMember,
    getRegions: getRegions,
    getShortUrl: getShortUrl,
    getRealURLParamsForGUID: getRealURLParamsForGUID,
    getRealURLParamsForUUID: getRealURLParamsForUUID,
    getShortUrlParams: getShortUrlParams
}
